import React, { useEffect } from "react";
import { isValidImgURL, hostingServices } from "../../common/utilities";
import Container from "@material-ui/core/Container";

import styles from "./PlayerBanner.module.scss";

import coverDefault from "../../images/header/cover-sample.jpg";
import profileDefault from "../../images/header/profile-sample.jpg";

export default function PlayerBanner({ data }) {
  //if data is false, we know there is no custom avatar or banner; otherwise we are waiting for the posibility of one
  const bannerURL =
    data == null || data == false
      ? data
      : data.URL1_STATUS == 1 && isValidImgURL(data.URL1_TEXT, hostingServices)
      ? data.URL1_TEXT
      : "";
  const avatarURL =
    data == null || data == false
      ? data
      : data.URL2_STATUS == 1 && isValidImgURL(data.URL2_TEXT, hostingServices)
      ? data.URL2_TEXT
      : "";

  const bannerImgStyles =
    data == null
      ? data
      : {
          backgroundImage: bannerURL
            ? `url(${bannerURL}`
            : `url(${coverDefault}`
        };
  const profileImgStyles =
    data == null
      ? data
      : {
          backgroundImage: avatarURL
            ? `url(${avatarURL})`
            : `url(${profileDefault}`
        };

  return (
    <div className={styles.banner__container} style={bannerImgStyles}>
      <Container maxWidth="xl" classes={{ root: styles.avatar__parent }}>
        <div className={styles.avatar__child} style={profileImgStyles} />
      </Container>
    </div>
  );
}
